<script>
import { Scatter, mixins } from "vue-chartjs";
import chartMixins from "./chartMixin";
// import * as ChartAnnotation from "chartjs-plugin-annotation";

const { reactiveProp } = mixins;
export default {
	extends: Scatter,
	// components: [ChartAnnotation],
	mixins: [chartMixins, reactiveProp],
	props: {
		yScaleLabel: {
			type: Object,
			default: () => {}
		},
		xScaleLabel: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			dataset: []
		};
	},
	computed: {
		yAxis() {
			return this.dataset.map((set) => set.y);
		},
		options() {
			return {
				title: {
					display: true,
					text: this.chartData.title
				},
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					display: false
				},
				scales: {
					yAxes: [
						{
							display: true,
							scaleLabel: { display: true, labelString: "Open searches" },
							ticks: {
								beginAtZero: true, // minimum value will be 0.
								suggestedMax: Math.max(...this.yAxis) + 1,
								stepSize: Math.max(...this.yAxis) <= 5 ? 1 : 2
							}
						}
					],
					xAxes: [
						{
							display: true,
							gridLines: {
								drawOnChartArea: false
							},
							scaleLabel: { display: true, labelString: "Days" },
							ticks: {
								beginAtZero: true,
								fontSize: 13,
								autoSkip: true
								// stepSize: 1
							}
						}
					]
				},
				tooltips: {
					mode: "nearest",
					enabled: this.showTooltip,
					bodyFontFamily:
						"proxima-nova, 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
					bodyFontSize: 14,
					callbacks: {
						label: function (tooltipItem, data) {
							var label =
								data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]; //data.labels[tooltipItem.index];
							return "Open searches: " + label.y + ", Days open: " + label.x;
						}
					},
					xPadding: 20,
					yPadding: 10
				}
				// plugins: [ChartAnnotation],
				// annotation: {
				// 	annotations: [
				// 		{
				// 			type: "line",
				// 			mode: "vertical",
				// 			scaleID: "x-axis-0",
				// 			value: "8",
				// 			borderColor: "red",
				// 			borderWidth: 5
				// 		}
				// 	]
				// }
			};
		}
	},
	mounted() {
		this.dataset = this.chartData.datasets[0].data || [];
		this.renderChart(this.chartData, this.options);
	}
};
</script>
